export default "__VITE_ASSET__061dac3e__"